import { IProfitCostList, IProfitCostParam, IProfitSharing, IProfitSharingParam } from '../../../types';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 分账产品 - 代理分润列表
 */
export async function queryProfitSharingCompany(param: IProfitSharingParam) {
  let data = [] as IProfitSharing[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IProfitSharingParam;

  try {
    const { code, context, message } = await Http.get<{ data: IProfitSharing[]; total: number }>(`${hostUrl}/disburse/company-profit-sharing/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IProfitSharing[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 分账产品 - 代理分润详情
 */
export async function queryProfitSharingDetail(param: IProfitCostParam) {
  let data = [] as IProfitCostList[];

  param = JSON.parse(JSON.stringify(param)) as IProfitCostParam;

  try {
    const { code, context, message } = await Http.get<IProfitCostList[]>(`${hostUrl}/disburse/company-profit-sharing/cost-list`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IProfitCostList[];

      data = items || [] as IProfitCostList[];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 分账产品 - 代理分润保存
 */
export async function updateProfitSharing(param: IProfitCostParam) {
  param = JSON.parse(JSON.stringify(param)) as IProfitCostParam;

  try {
    const { code, message } = await Http.post(`${hostUrl}/disburse/company-profit-sharing/modify`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}